import React from "react";
import { useParams } from "react-router-dom";
import RoleForm from "./RoleForm";

const EditRole = () => {
  const { id } = useParams();
  return <RoleForm mode="edit" roleId={id} />;
};

export default EditRole;
